import { useState } from "react";
import { Button, message } from "antd";
import { useTranslation } from "react-i18next";

import { MISSING_TRANSLATION } from "../../../../../i18n";
import { useAuth } from "../../../../../../modules/auth/useAuth";
import {
  clearCustomerManager,
  setCustomerManager,
} from "../../../../../../modules/integrations/accounts";
import { IUser } from "../../../../../types";

interface ClientAssignButtonProps {
  user: IUser;
  onSuccess: () => void;
}

const ClientAssignButton = ({ user, onSuccess }: ClientAssignButtonProps) => {
  const { t } = useTranslation();
  const { getOperatorEmail, getOperatorId } = useAuth();
  const [loading, setLoading] = useState(false);

  const operatorEmail = getOperatorEmail();
  const isAssignedToMe = user.kontaxUser?.assigneeEmail === operatorEmail;

  const handleClick = async () => {
    setLoading(true);
    try {
      if (isAssignedToMe) {
        await clearCustomerManager(user.publicId);
        message.success(t("releaseClient") || MISSING_TRANSLATION);
      } else {
        // Self-assign: the acting operator's accounts id comes straight from the
        // access token (always present as a required claim).
        const operatorId = getOperatorId();
        if (!operatorId) {
          throw new Error("Could not resolve the acting operator id");
        }
        await setCustomerManager(user.publicId, operatorId);
        message.success(t("takeOverClient") || MISSING_TRANSLATION);
      }
      onSuccess();
    } catch {
      message.error("An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      type={isAssignedToMe ? "primary" : "default"}
      loading={loading}
      onClick={handleClick}
    >
      {isAssignedToMe
        ? t("releaseClient") || MISSING_TRANSLATION
        : t("takeOverClient") || MISSING_TRANSLATION}
    </Button>
  );
};

export default ClientAssignButton;
